export const Manifesto = () => {
  const confessions = [
    "You've said 'tomorrow' 74 times this month. Tomorrow is a graveyard.",
    "You scroll when you should be building. Each swipe is another coffin nail.",
    "You justify weakness like it's a strategy. It's not. It's surrender.",
    "Your comfort zone is a velvet-lined coffin. And you're already inside.",
    "You know exactly what needs to be done. You've always known. You're just too afraid to do it.",
    "Every broken promise is a shovel of dirt on your own grave.",
    "You negotiate with yourself like a hostage. Pathetic.",
    "Discipline isn't built. It's bled for. And you haven't bled yet."
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-void to-secondary/30">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-5xl md:text-6xl font-black text-center mb-4 tracking-tight">
          <span className="text-blood-bright">The Manifesto</span>
        </h2>
        <p className="text-center text-steel text-xl mb-16 italic">Broken Promises</p>
        
        <div className="space-y-6">
          {confessions.map((confession, index) => (
            <div 
              key={index}
              className="border-l-4 border-blood pl-6 py-4 bg-card/50 backdrop-blur-sm transition-all hover:border-blood-bright hover:bg-card/80"
            >
              <p className="text-xl md:text-2xl text-foreground font-medium">
                {confession}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center border-t-2 border-blood pt-12">
          <p className="text-3xl md:text-4xl font-bold text-blood-bright uppercase tracking-wider mb-4">
            This isn't motivation.
          </p>
          <p className="text-3xl md:text-4xl font-bold text-foreground uppercase tracking-wider mb-6">
            It's execution.
          </p>
          <p className="text-xl text-steel italic max-w-2xl mx-auto">
            No fluff. No theory. No gentle hand-holding. Just brutal protocols that monks, convicts, and millionaires use to dominate their minds, bodies, and futures.
          </p>
        </div>
      </div>
    </section>
  );
};
